import React from 'react';
import styled from 'styled-components';

import { useMediaSize } from '../../../hooks';
import { GlobusLogoImage } from '../../../img';
import Portal from '../../Portal';
import SpinningRing from './SpinningRing';

interface Props {
    className?: string;
    size?: number;
    sizeMobile?: number;
    portal?: boolean;
}

const LoadingSpinnerWithImage: React.FC<Props> = (props) => {
    const {
        className,
        size = 128,
        sizeMobile = 78,
        portal = false
    } = props;

    const media = useMediaSize();

    const currentSize = media.isMobile ? sizeMobile : size;

    const spinner = (
        <Root className={ className }
            size={ currentSize }>
            <SpinningRing />
            <ImageContainer>
                <StyledGlobusLogoImage />
            </ImageContainer>
        </Root>
    );

    if (portal) {
        return (<Portal>
            <PortalRoot>
                { spinner }
            </PortalRoot>
        </Portal>);
    }

    return spinner;
};

export default React.memo(LoadingSpinnerWithImage);

const Root = styled.div<{ size: number }>`
  align-items: center;
  border-radius: ${ ({ size }) => size }px;
  display: inline-flex;
  height: ${ ({ size }) => size }px;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: ${ ({ size }) => size }px;
`;

const StyledGlobusLogoImage = styled(GlobusLogoImage)``;

const ImageContainer = styled.div`
    background-color: transparent;
    border-radius: 50%;
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    overflow: hidden;
    z-index: 10;

    ${ StyledGlobusLogoImage } {
        width: 45%;
        height: 52%;
        margin-left: 25%;
    }
`;

const PortalRoot = styled.div`
    align-items: center;
    display: flex;
    height: 100dvh;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100vw;
`;
